export class AiRoleModel {
    RoleId: number;
    RoleTitle: string;
    PreText: string;
    PostText: string;
    DefaultPrompt: string;
    DisplaySerial?: number;
    OrgId?: number;
    IsDefault?: boolean;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedOn?: Date;
    LastModifiedBy?: number;
    LastModifiedOn?: Date;
}